import c1 from './course1-sip-foundations';
import c2 from './course2-call-flows';
import c3 from './course3-meet-kamailio';
import c4 from './course4-config-language';
import c5 from './course5-routing';
import c6 from './course6-security';
import c7 from './course7-scale';

export const courses = [c1, c2, c3, c4, c5, c6, c7];
export const STEP_COUNT = courses.length;

export const getCourse = (id) => courses.find((c) => c.id === id);

export const allLessons = courses.flatMap((course) =>
  course.lessons.map((lesson, index) => ({ course, lesson, index }))
);

export const totalLessons = allLessons.length;
export const totalMinutes = allLessons.reduce((sum, { lesson }) => sum + lesson.minutes, 0);

// plain text of a lesson, used by search
export const lessonText = (lesson) =>
  lesson.blocks
    .map((b) => [b.text, b.title, ...(b.items || []).map((i) => (typeof i === 'string' ? i : `${i.title} ${i.text}`)), ...(b.rows || []).flat()]
      .filter(Boolean)
      .join(' '))
    .join(' ');
